import React, { useState, useEffect } from "react";
import {
  Button,
  Flex,
  Td,
  Text,
  Tr,
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  Input
} from "@chakra-ui/react";
import useCustomToast from "components/Toast/useCustomToast";
import moment from 'moment';
import { usePostData } from "apiService";
import { EditIcon, DeleteIcon } from '@chakra-ui/icons';

function TableArrestTypes(props) {
  const { id, name, lastItem, handleDeleteType } = props;
  const { success, error } = useCustomToast();
  const { postData } = usePostData();
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);
  const [newTypeName, setNewTypeName] = useState("");
  const onCloseEdit = () => setIsEditOpen(false);

  useEffect(() => {
    // Mettre à jour le nom du type dans le champ d'entrée lorsque la boîte de dialogue est ouverte
    if (isEditOpen) {
      setNewTypeName(name);
    }
  }, [isEditOpen, name]);

  useEffect(() => {
    setNewTypeName(name);
  }, [name]);

  const handleEdit = () => {
    setIsEditOpen(true);
  }

  const handleDelete = () => {
    setIsDeleteOpen(true);
  }

  const onCloseDelete = () => setIsDeleteOpen(false);

  const confirmDelete = async () => {
    try {
      // Appeler la méthode handleDeleteType du parent
      handleDeleteType(id);

      // Fermer la boîte de dialogue
      setIsDeleteOpen(false);
    } catch (err) {
      error("Erreur", "Impossible de supprimer le type");
    }
  }

  const confirmEdit = async () => {
    try {
      // Mettre à jour le type avec le nouveau nom
      const response = await postData(`updateArrestType`, { id: id, name: newTypeName });

      if (response) {
        setIsEditOpen(false);
        success("Type modifié", "Le type a été modifié");
      }
    } catch (err) {
      error("Erreur", "Impossible de mettre à jour le type");
    }
  }

  return (
    <>
      <Tr>
        <Td
          minWidth={{ sm: "250px" }}
          ps='0px'
          border={lastItem ? "none" : null}
          borderBottomColor='#56577A'>
          <Flex align='center' minWidth='100%' flexWrap='nowrap'>
            <Flex direction='column'>
              <Text
                fontSize='sm'
                color='#fff'
                fontWeight='normal'
                minWidth='100%'>
                {newTypeName}
              </Text>
            </Flex>
          </Flex>
        </Td>
        <Td border={lastItem ? "none" : null} borderBottomColor='#56577A'>
          <Flex justifyContent="flex-end">
            <Button
            mr={2}
              onClick={() => handleDelete(id)}
              bg='red.400'
              color='white'
              _hover={{ bg: "red.300" }}
              _active={{ bg: "red.300" }}
              _focus={{ boxShadow: "none" }}
              size='sm'
              px='1.5rem'
              fontSize='sm'
              fontWeight='normal'
              ms='1rem'>
              <DeleteIcon/>
            </Button>
            <Button
              onClick={handleEdit}
              bg='brand.200'
              color='white'
              _hover={{ bg: "brand.100" }}
              _active={{ bg: "brand.100" }}
              _focus={{ boxShadow: "none" }}
              size='sm'
              px='1.5rem'
              fontSize='sm'
              fontWeight='normal'>
              <EditIcon/>
            </Button>
          </Flex>
        </Td>
      </Tr>

      {/* Popup de modification */}
      <AlertDialog
        isOpen={isEditOpen}
        leastDestructiveRef={null}
        onClose={onCloseEdit}>
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader>Modifier</AlertDialogHeader>
            <AlertDialogBody>
              <Input
                value={newTypeName}
                onChange={(e) => setNewTypeName(e.target.value)}
                placeholder="Nouveau nom du type"
              />
            </AlertDialogBody>
            <AlertDialogFooter>
              <Button onClick={onCloseEdit}>Annuler</Button>
              <Button colorScheme="blue" ml={3} onClick={confirmEdit}>
                Modifier
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>

      {/* Popup de suppression */}
      <AlertDialog
        isOpen={isDeleteOpen}
        leastDestructiveRef={null}
        onClose={onCloseDelete}>
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader>Confirmation de suppression</AlertDialogHeader>
            <AlertDialogBody>
              Êtes-vous sûr de vouloir supprimer le type <Text as={"span"} fontWeight="bold">{name}</Text> ?<br /><br />⚠️ Cette action est irréversible et toutes les arrestations associées n'auront plus de type.
            </AlertDialogBody>
            <AlertDialogFooter>
              <Button onClick={onCloseDelete}>Annuler</Button>
              <Button colorScheme="red" ml={3} onClick={confirmDelete}>
                Supprimer
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  );
}

export default TableArrestTypes;
